import { subtitleTypes } from "@/mocks/watchGuide";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function SubtitleTypes() {
  return (
    <section id="subtitles" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="字幕科普 · 看懂差别"
          title="同样是中文字幕，为什么观感差这么多"
          desc="字幕的质量、来源和形式各不相同。了解这四类区别之后，你就知道该在播放器里找什么、以及为什么有的剧看起来更「顺」。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {subtitleTypes.map((s, idx) => (
            <article
              key={s.id}
              className="relative rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
                  <i className={`${s.icon} text-2xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">
                    {s.name}
                  </h3>
                  <span className="text-xs text-foreground-500">
                    类型 {"0" + (idx + 1)}
                  </span>
                </div>
              </div>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              <p className="mt-3 text-xs md:text-sm text-secondary-800 flex items-start gap-1.5">
                <i className="ri-lightbulb-line mt-0.5"></i>
                {s.best}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}